import { Button } from '@coop/components';

import { Helpers } from '../../../../../utility/helpers';
import A11yPrice from '../../../../ecommerce/components/A11yPrice';
import { type RecipeCartState } from '../../../../recipe/hooks/useRecipeCart';
import { useCurrentPriceType } from '../../../hooks/useCurrentPriceType';
import { PriceType } from '../../../models/priceData/priceData';
import styles from './BuyableRecipe.module.scss';

const BuyableRecipeCartFooter = (props: {
    recipeCart: RecipeCartState;
    onBuyClick: () => void;
}) => {
    const { currentPriceType } = useCurrentPriceType();

    const totalProducts = props.recipeCart.items
        .filter((item) => item.purchasable)
        .reduce((curr, next) => curr + (next.quantity || 0), 0);

    return (
        <div className={styles.CartFooter}>
            <div className={styles.Values}>
                <span>{`${totalProducts} ${totalProducts > 0 ? 'varor' : 'vara'}`}</span>
                <span>
                    <A11yPrice
                        priceData={props.recipeCart.totalPriceData}
                        priceType={currentPriceType}
                    />
                    {currentPriceType === PriceType.ExcludeTax && (
                        <span className="u-textWeightNormal u-textSmall">
                            {Helpers.getPriceTypeText(PriceType.ExcludeTax)}
                        </span>
                    )}
                </span>
            </div>
            <Button size="large" onClick={props.onBuyClick}>
                Lägg i varukorg
            </Button>
        </div>
    );
};

export default BuyableRecipeCartFooter;
